(function(){
  /* Nested (3rd-level) submenu flyout is CSS :hover driven (see ghats-dropdown.css).
     This script only flags parent links that have a nested list, so the side arrow
     (>) shows and screen readers announce the popup. No click handling. */
  function nested(){ return document.querySelectorAll('.menu-list__submenu .mega-menu__link--parent'); }
  function init(){
    var l = nested();
    for(var i=0;i<l.length;i++){
      var link = l[i], ul = link.nextElementSibling;
      if(ul && ul.tagName === 'UL' && !link.hasAttribute('data-lb-nested')){
        link.setAttribute('data-lb-nested','1');
        link.setAttribute('aria-haspopup','true');
      }
    }
  }
  if(document.readyState !== 'loading'){ init(); } else { document.addEventListener('DOMContentLoaded', init); }
  document.addEventListener('pointerover', function(e){ if(e.target && e.target.closest && e.target.closest('.header-menu')){ init(); } }, { passive: true });
})();

(function(){
  /* Product media gallery: remove the infinite-loop wrap-around so the mobile
     image carousel does not jump/loop on its own. Scroll-snapping is untouched. */
  function deloop(){
    var list = document.querySelectorAll('media-gallery slideshow-component[infinite]');
    for(var i=0;i<list.length;i++){ list[i].removeAttribute('infinite'); }
  }
  function start(){
    deloop();
    /* The gallery is re-rendered on variant change; strip infinite again when that happens. */
    try {
      var mo = new MutationObserver(function(){ deloop(); });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch(e){}
  }
  if(document.readyState !== 'loading'){ start(); } else { document.addEventListener('DOMContentLoaded', start); }
})();
